import type { NumberSpeller } from './types'

// Bengali has an irregular word for every number 0–99 (West Bengal spoken forms).
const ONES = [
  'শূন্য', 'এক', 'দুই', 'তিন', 'চার', 'পাঁচ', 'ছয়', 'সাত', 'আট', 'নয়',
  'দশ', 'এগারো', 'বারো', 'তেরো', 'চোদ্দ', 'পনেরো', 'ষোলো', 'সতেরো', 'আঠারো', 'উনিশ',
  'কুড়ি', 'একুশ', 'বাইশ', 'তেইশ', 'চব্বিশ', 'পঁচিশ', 'ছাব্বিশ', 'সাতাশ', 'আঠাশ', 'ঊনত্রিশ',
  'তিরিশ', 'একত্রিশ', 'বত্রিশ', 'তেত্রিশ', 'চৌত্রিশ', 'পঁয়ত্রিশ', 'ছত্রিশ', 'সাঁইত্রিশ', 'আটত্রিশ', 'ঊনচল্লিশ',
  'চল্লিশ', 'একচল্লিশ', 'বিয়াল্লিশ', 'তেতাল্লিশ', 'চুয়াল্লিশ', 'পঁয়তাল্লিশ', 'ছেচল্লিশ', 'সাতচল্লিশ', 'আটচল্লিশ', 'ঊনপঞ্চাশ',
  'পঞ্চাশ', 'একান্ন', 'বাহান্ন', 'তিপ্পান্ন', 'চুয়ান্ন', 'পঞ্চান্ন', 'ছাপ্পান্ন', 'সাতান্ন', 'আটান্ন', 'ঊনষাট',
  'ষাট', 'একষট্টি', 'বাষট্টি', 'তেষট্টি', 'চৌষট্টি', 'পঁয়ষট্টি', 'ছেষট্টি', 'সাতষট্টি', 'আটষট্টি', 'ঊনসত্তর',
  'সত্তর', 'একাত্তর', 'বাহাত্তর', 'তিয়াত্তর', 'চুয়াত্তর', 'পঁচাত্তর', 'ছিয়াত্তর', 'সাতাত্তর', 'আটাত্তর', 'ঊনআশি',
  'আশি', 'একাশি', 'বিরাশি', 'তিরাশি', 'চুরাশি', 'পঁচাশি', 'ছিয়াশি', 'সাতাশি', 'অষ্টআশি', 'ঊননব্বই',
  'নব্বই', 'একানব্বই', 'বিরানব্বই', 'তিরানব্বই', 'চুরানব্বই', 'পঁচানব্বই', 'ছিয়ানব্বই', 'সাতানব্বই', 'আটানব্বই', 'নিরানব্বই'
]
// "একশো", "দুশো", … "নশো"; beyond nine the regular word takes -শো ("উনিশশো").
const HUNDREDS = ['', 'একশো', 'দুশো', 'তিনশো', 'চারশো', 'পাঁচশো', 'ছশো', 'সাতশো', 'আটশো', 'নশো']

function hundreds(h: number): string {
  return h < 10 ? HUNDREDS[h] : `${ONES[h]}শো`
}

function withHundreds(h: number, r: number): string {
  return [h ? hundreds(h) : '', r ? ONES[r] : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return ONES[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'কোটি'], [100_000, 'লাখ'], [1000, 'হাজার']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(withHundreds(Math.floor(rest / 100), rest % 100))
  return parts.join(' ')
}

export const bn: NumberSpeller = {
  spell,
  // 2000–2099: "দুই হাজার ছাব্বিশ"; 1100–1999: "উনিশশো পঁচাশি".
  year: (n) => (n >= 1100 && n < 2000 ? withHundreds(Math.floor(n / 100), n % 100) : spell(n)),
  rupees: 'টাকা'
}
